function drawRoundedRect(
  ctx: CanvasRenderingContext2D,
  x: number,
  y: number,
  w: number,
  h: number,
  r: number,
) {
  const radius = Math.min(r, w / 2, h / 2);
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + w, y, x + w, y + h, radius);
  ctx.arcTo(x + w, y + h, x, y + h, radius);
  ctx.arcTo(x, y + h, x, y, radius);
  ctx.arcTo(x, y, x + w, y, radius);
  ctx.closePath();
}

/**
 * Turo-style price pill at the original map size/anchor.
 * Canvas is drawn at devicePixelRatio so labels stay sharp on mobile.
 */
export function createPriceMarkerIcon(
  price: number | null | undefined,
  selected = false,
  hovered = false,
): google.maps.Icon | undefined {
  const text = price ? `$${Math.round(price)}` : 'N/A';
  const textLength = text.length;
  const padding = 12;
  const charWidth = 7.5;
  const width = Math.max(textLength * charWidth + padding * 2, 50);
  const height = 24;
  const fontSize = 12;
  const borderRadius = 14;
  const dpr = Math.min(typeof window !== 'undefined' ? window.devicePixelRatio || 1 : 1, 3);

  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(width * dpr);
  canvas.height = Math.ceil(height * dpr);
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    return undefined;
  }

  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  ctx.imageSmoothingEnabled = false;

  const highlighted = selected || hovered;

  ctx.fillStyle = 'rgba(0, 0, 0, 0.25)';
  drawRoundedRect(ctx, 1, 2, width - 2, height - 2, borderRadius);
  ctx.fill();

  ctx.fillStyle = highlighted ? '#000000' : '#FFFFFF';
  drawRoundedRect(ctx, 0, 0, width, height, borderRadius);
  ctx.fill();

  ctx.fillStyle = highlighted ? '#FFFFFF' : '#000000';
  ctx.font = `600 ${fontSize}px -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(text, width / 2, height / 2);

  return {
    url: canvas.toDataURL('image/png'),
    scaledSize: new google.maps.Size(width, height),
    anchor: new google.maps.Point(width / 2, height),
  };
}
